import { GroupType } from "@nova/constants"
import { Group } from "@nova/protobuf"
import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux/rootReducer"
import { memoize } from "nodash"
import { selectAllEntities } from "panels/content/side-panel/slice"

const root = (state: RootState) => state.project.data.groups

export const selectAllGroups = (s: RootState) => root(s)
export const selectGroups = createSelector([selectAllGroups], (groups) =>
    groups.filter((e) => !e.groupType)
)
export const selectGroupsMap = createSelector([selectAllGroups], (groups) => {
    return groups.reduce(
        (acc, cur) => {
            acc[cur.id] = cur
            return acc
        },
        {} as Record<string, Group>
    )
})
export const selectGroupById = memoize((groupId: string) =>
    createSelector([selectGroupsMap], (groupMap) => groupMap[groupId])
)
export const selectChildrenForGroupById = memoize((groupId: string) =>
    createSelector([selectAllEntities], (entities) =>
        entities.filter((entity) => entity.parentId === groupId)
    )
)
export const selectPDFGroups = createSelector([selectAllGroups], (groups) =>
    groups.filter((e) => e.groupType === GroupType.PDF)
)

export const selectNextGroupNumber = createSelector(
    [selectGroups, selectPDFGroups],
    (groups, pdfGroups) => groups.length + pdfGroups.length + 1
)
